import fetchAPI from '../fetchAPI';

export const callStartCohortReport = async (payload: {
  startDate: string;
  endDate: string;
  cost: string;
  title?: string;
  description?: string;
  locationIds?: string[];
  businessType?: string;
  password?: string;
  // When true, the background job runner syncs each cohort location's
  // contacts (using the report window as `daysBack`) before generating
  // the report. Mirrors the perf-report flow.
  syncContactsFirst?: boolean;
}): Promise<iResponse<{ jobId: string; status: string }>> => {
  const response = await fetchAPI<{ jobId: string; status: string }>({
    method: 'POST',
    route: 'artifacts',
    data: { ...payload, kind: 'cohort' }
  });
  return response;
};

export default callStartCohortReport;
